const MAX_LOGS = 80;
const logs = [];

let enabled = false;
let listeners = [];

export function setVoiceDebugEnabled(value) {
  enabled = !!value;
  voiceDebug("config", `调试模式: ${enabled ? "开启" : "关闭"}`);
}

export function isVoiceDebugEnabled() {
  return enabled;
}

export function onVoiceDebugLog(fn) {
  if (typeof fn === "function") {
    listeners.push(fn);
  }
}

function notifyListeners() {
  listeners.forEach((fn) => {
    try {
      fn(logs.slice());
    } catch (e) {
      console.error(e);
    }
  });
}

/**
 * @param {string} tag
 * @param {unknown} payload
 */
export function voiceDebug(tag, payload) {
  const time = new Date().toLocaleTimeString();
  let text = "";
  if (payload === undefined) {
    text = "";
  } else if (typeof payload === "string") {
    text = payload;
  } else {
    try {
      text = JSON.stringify(payload);
    } catch (e) {
      text = String(payload);
    }
  }

  const entry = { time, tag, text };
  logs.unshift(entry);
  if (logs.length > MAX_LOGS) {
    logs.length = MAX_LOGS;
  }

  const line = `[VoiceDebug][${tag}]${text ? " " + text : ""}`;
  console.log(line, payload !== undefined && typeof payload === "object" ? payload : "");

  if (enabled) {
    notifyListeners();
  }
}

export function getVoiceDebugLogs() {
  return logs.slice();
}

export function clearVoiceDebugLogs() {
  logs.length = 0;
  notifyListeners();
}

export function formatVoiceDebugLogs(logList) {
  return logList
    .map((item) => `${item.time} [${item.tag}] ${item.text}`)
    .join("\n");
}

export function getAudioSnapshot(audioEl) {
  if (!audioEl) {
    return { ok: false, reason: "audio 元素不存在" };
  }
  const err = audioEl.error;
  return {
    ok: true,
    currentSrc: audioEl.currentSrc || audioEl.src || "",
    readyState: audioEl.readyState,
    networkState: audioEl.networkState,
    paused: audioEl.paused,
    muted: audioEl.muted,
    volume: audioEl.volume,
    ended: audioEl.ended,
    duration: audioEl.duration,
    error: err
      ? { code: err.code, message: err.message || mediaErrorText(err.code) }
      : null,
  };
}

function mediaErrorText(code) {
  const map = {
    1: "MEDIA_ERR_ABORTED",
    2: "MEDIA_ERR_NETWORK",
    3: "MEDIA_ERR_DECODE",
    4: "MEDIA_ERR_SRC_NOT_SUPPORTED",
  };
  return map[code] || "UNKNOWN";
}

export function shouldEnableVoiceDebugFromUrl() {
  try {
    const href = window.location.href;
    if (/[?&]voiceDebug=1/.test(href)) return true;
    if (localStorage.getItem("voiceDebug") === "1") return true;
  } catch (e) {
    /* ignore */
  }
  return false;
}
